import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useDarkMode } from "../../contexts/DarkModeContext";
import "./ThemeToggle.scss";

const ThemeToggle = () => {
  const { isDarkMode, toggleDarkMode } = useDarkMode();
  const [bodySize, setBodySize] = useState(22.5);
  const [padding, setPadding] = useState(4.5);
  const [toggleWidth, setToggleWidth] = useState(82.5);

  useEffect(() => {
    const updateSizes = () => {
      if (window.innerWidth <= 480) {
        setBodySize(18.75);
        setPadding(3);
        setToggleWidth(60);
      } else if (window.innerWidth <= 768) {
        setBodySize(20.25);
        setPadding(3.75);
        setToggleWidth(67.5);
      } else {
        setBodySize(22.5);
        setPadding(4.5);
        setToggleWidth(82.5);
      }
    };

    updateSizes();
    window.addEventListener("resize", updateSizes);
    return () => window.removeEventListener("resize", updateSizes);
  }, []);

  const handleClick = (e) => {
    e.stopPropagation();
    toggleDarkMode();
  };

  // Calculate the right position: toggle width - body size - padding
  const rightPosition = toggleWidth - bodySize - padding;

  return (
    <motion.button
      className={`theme-toggle ${isDarkMode ? "dark-mode" : "light-mode"}`}
      onClick={handleClick}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      transition={{ duration: 0.2 }}
      style={{ zIndex: 20 }}
    >
      <div className="toggle-background">
        {/* Light Mode: Clouds */}
        {!isDarkMode && (
          <motion.div
            className="clouds"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <div className="cloud cloud-1"></div>
            <div className="cloud cloud-2"></div>
            <div className="cloud cloud-3"></div>
          </motion.div>
        )}

        {/* Dark Mode: Stars */}
        {isDarkMode && (
          <motion.div
            className="stars"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <div className="star star-1"></div>
            <div className="star star-2"></div>
            <div className="star star-3"></div>
            <div className="star star-4"></div>
            <div className="star star-5"></div>
            <div className="star star-6"></div>
          </motion.div>
        )}

        {/* Sun/Moon Icon */}
        <motion.div
          className="celestial-body"
          style={{
            width: `${bodySize}px`,
            height: `${bodySize}px`,
          }}
          animate={{
            x: isDarkMode ? rightPosition : padding,
            y: "-50%",
          }}
          transition={{
            type: "spring",
            stiffness: 300,
            damping: 30,
          }}
        >
          {!isDarkMode ? (
            <div className="sun"></div>
          ) : (
            <div className="moon">
              <div className="moon-spot spot-1"></div>
              <div className="moon-spot spot-2"></div>
              <div className="moon-spot spot-3"></div>
            </div>
          )}
        </motion.div>
      </div>
    </motion.button>
  );
};

export default ThemeToggle;
